import { environment } from '../../environments/environment';

export interface INavItem {
  link: string;
  icon: string;
  name: string;
  visible: boolean;
}

export interface INavGroup {
  title: string;
  items: INavItem[];
}

// Menu structure only. Visibility per build comes from the `eng` flag.
export function buildAdminMenu(eng: boolean): { groups: INavGroup[]; footer: INavItem[] } {
  return {
    groups: [
      {
        title: 'Content',
        items: [
          { link: '/feedback', icon: 'feedback', name: 'Feedback', visible: eng },
          { link: '/course', icon: 'golf_course', name: 'Courses', visible: true },
          { link: '/topic', icon: 'flutter_dash', name: 'Topics', visible: true },
          { link: '/category', icon: 'category', name: 'Categories', visible: true },
          { link: '/source', icon: 'record_voice_over', name: 'Sources', visible: true },
          { link: '/news', icon: 'newspaper', name: 'News', visible: true },
          { link: '/page', icon: 'pages', name: 'Pages', visible: true },
          { link: '/comment', icon: 'comment', name: 'Comments', visible: true },
          { link: '/navigation', icon: 'navigation', name: 'Navigation', visible: eng },
        ]
      },
      {
        title: 'Commerce',
        items: [
          { link: '/order', icon: 'shopping_cart', name: 'Orders', visible: eng },
          { link: '/skladchina', icon: 'savings', name: 'Skladchina', visible: eng },
          { link: '/package', icon: 'storage', name: 'Packages', visible: true },
          { link: '/promo', icon: 'card_giftcard', name: 'Promo', visible: eng },
          { link: '/income', icon: 'paid', name: 'Income', visible: true },
        ]
      },
      {
        title: 'People',
        items: [
          { link: '/user', icon: 'people', name: 'Users', visible: true },
          { link: '/downloads', icon: 'download', name: 'Downloads', visible: true },
          { link: '/observer', icon: 'psychology', name: 'Observer', visible: true },
        ]
      },
      {
        title: 'Communication',
        items: [
          { link: '/support', icon: 'support_agent', name: 'Support', visible: true },
          { link: '/mail', icon: 'mail', name: 'Mail', visible: true },
          { link: '/mass', icon: 'campaign', name: 'Mass', visible: true },
          { link: '/system-message', icon: 'notifications', name: 'System Messages', visible: eng },
          { link: '/push-subscriptions', icon: 'notifications_active', name: 'Push Subscriptions', visible: true },
        ]
      },
      {
        title: 'Operations',
        items: [
          { link: '/kanban', icon: 'view_kanban', name: 'Board', visible: environment.kanban },
          { link: '/health', icon: 'health_and_safety', name: 'Health', visible: true },
          { link: '/servers', icon: 'monitor_heart', name: 'Servers', visible: true },
          { link: '/cron-log', icon: 'terminal', name: 'Cron logs', visible: true },
          { link: '/log', icon: 'list', name: 'Log', visible: eng },
          { link: '/vpn', icon: 'vpn_key', name: 'VPN', visible: eng },
        ]
      },
    ],
    footer: [
      { link: '/setting', icon: 'settings', name: 'Settings', visible: true },
    ],
  };
}
